import { useGetLastVisitedQuery } from 'API/order/VisitTrackingAPI';
import { DateTime } from 'luxon';
import React from 'react';
import { DateFormat } from '../../../ui-toolkit/utilities/getDateString';

export interface ILastVisitProps {
  fileNumber: string;
}

export const LastVisit: React.FC<ILastVisitProps> = ({ fileNumber }) => {
  const { data = '' } = useGetLastVisitedQuery(fileNumber);
  const displayValue = data ?? '';
  return (
    <div title={displayValue && DateTime.fromISO(displayValue).toLocal().toFormat(DateFormat.shortDateTime)}>
      {displayValue && DateTime.fromISO(displayValue).toLocal().toFormat(DateFormat.short)}
    </div>
  );
};
